import api from '@/api'

export default {
  state: {
    roles: []
  },
  mutations: {
    SET_ROLES(state, data) {
      state.roles = data
    },
    ADD_ROLE(state, role) {
      // find existing role by name
      let existing = state.roles.find((r) => r.id === role.id)
      if (existing) {
        Object.assign(existing, role)
      } else {
        state.roles.push(role)
      }
    },
    UPDATE_ROLE(state, role) {
      let existing = state.roles.find((r) => r.id === role.id)
      if (existing) {
        Object.assign(existing, role)
      } else {
        state.roles.push(role)
      }
    },
    DELETE_ROLE(state, role) {
      let index = state.roles.findIndex((r) => r.id === role.id)
      if (index >= 0) {
        state.roles.splice(index, 1)
      }
    }
  },
  actions: {
    async loadRoles({ commit }, stations) {
      let resp = await api.roles.getRoles(stations)
      commit('SET_ROLES', resp.data)
    },
    async getRole({ commit }, id) {
      let resp = await api.roles.getRole(id)
      return resp.data
    },
    async addRole({ commit }, roleData) {
      let resp = await api.roles.createRole(roleData)
      commit('ADD_ROLE', resp.data)
      return resp.data
    },
    async updateRole({ commit }, { id, ...data }) {
      let resp = await api.roles.updateRole(id, data)
      commit('UPDATE_ROLE', resp.data)
      return resp.data
    },
    async deleteRole({ commit }, id) {
      let resp = await api.roles.deleteRole(id)
      commit('DELETE_ROLE', { id })
      return resp.data
    }
  },
  getters: {
    roles(state) {
      return state.roles
    },
    currentStationRoles(state, getters, rootState, rootGetters) {
      let currentStationId = rootGetters.currentStation?.id
      if (!currentStationId) return []
      const globalRoles = state.roles?.filter((r) => r.workspace_id === null) || []
      const stationRoles = state.roles?.filter((r) => r.workspace_id === currentStationId) || []
      let combinedRoles = globalRoles.concat(stationRoles)

      // sort them by preferred order: editors, reporters, photographers, others alphabetically
      const preferredRoleOrder = ['reporter', 'photographer', 'editor']
      combinedRoles.sort((a, b) => {
        let aIndex = preferredRoleOrder.indexOf(a.role)
        let bIndex = preferredRoleOrder.indexOf(b.role)

        if (aIndex === -1) aIndex = preferredRoleOrder.length
        if (bIndex === -1) bIndex = preferredRoleOrder.length

        if (aIndex !== bIndex) {
          return aIndex - bIndex
        } else {
          return a.role.localeCompare(b.role)
        }
      })

      return combinedRoles
    }
  }
}
